import React, { useState, useRef, useEffect } from "react";
import './LocationScan.css';
import OdooService from '../../../services/odooService';
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../../components/ErrorModal/ErrorModal";
import LoadingOverlay from "../../../components/LoadingOverlay/LoadingOverlay";

const LocationScan = ({ onLocationScanned }) => {
    const navigate = useNavigate();
    const handleBack = () => navigate(-1);

    const [location, setLocation] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const manualInputRef = useRef(null);
    const scanInputRef = useRef(null);
    const scanTimeoutRef = useRef(null);

    useEffect(() => {
        if (!error && scanInputRef.current) {
            setTimeout(() => {
                scanInputRef.current.focus();
            }, 80);
        }
    }, [error]);

    const handleManualChange = (e) => {
        setLocation(e.target.value);
    };

    const handleManualKeyDown = (e) => {
        if (e.key === "Enter" && location.trim() !== "") {
            validateAndRedirect(location.trim());
        }
    };

    const handleScannerChange = (e) => {
        const code = e.target.value;

        if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);

        if (code.length > 0) {
            scanTimeoutRef.current = setTimeout(() => {
                validateAndRedirect(code.trim());
            }, 120);
        }
    };

    const handleScannerKeyDown = (e) => {
        if (e.key === "Enter" && scanInputRef.current.value.trim() !== "") {
            validateAndRedirect(scanInputRef.current.value.trim());
        }
    };

    const handleScannerKeyEvents = (e) => {
        if (e.key === "Backspace" || e.keyCode === 8) return e.preventDefault();
        if (e.key === "BrowserBack" || e.keyCode === 4) return e.preventDefault();
        if (e.key === "Enter" || e.keyCode === 13) return e.preventDefault();
        if (e.key.length > 1) return e.preventDefault();
    };

    const validateAndRedirect = async (barcode) => {
        setLoading(true);
        setError('');

        try {
            const result = await OdooService.validateLocationOrPackage(barcode);
            if (result.success) {
                if (result.type == 'location') {
                    navigate('/packagescan', {
                        state: {
                            location_id: result.location_id,
                            location_name: result.location_name
                        }
                    });
                }

                if (result.type == 'package') {
                    navigate('/packagescan', {
                        state: {
                            location_id: result.location_id,
                            location_name: result.location_name,
                            package_name: result.package_name
                        }
                    });
                }
            } else {
                setError(result.message);

                setLocation('');
                if (scanInputRef.current) {
                    scanInputRef.current.focus();
                }
            }
        } catch (err) {
            setError('Error de conexión: ' + err.message);
            if (scanInputRef.current) {
                scanInputRef.current.focus();
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="transfer-step-ls">
            <header className="step-header-ls">
                <h1>Toma de Inventario</h1>
                <p>Ubicación a inventariar</p>
            </header>

            <div className="step-content-ls">
                <div className="form-section-ls">
                    <h2>Escanee la ubicación o paquete</h2>

                    <div className="form-group-ls">
                        <input
                            ref={manualInputRef}
                            type="text"
                            value={location}
                            onChange={handleManualChange}
                            onKeyDown={handleManualKeyDown}
                            className="scan-input-ls"
                            placeholder="El código aparecerá aquí"
                        />

                        <input
                            ref={scanInputRef}
                            className="scan-hidden-ls"
                            type="text"
                            onChange={handleScannerChange}
                            onKeyDown={handleScannerKeyEvents}
                            autoFocus
                            inputMode="none"
                        />
                    </div>
                </div>
            </div>

            <div className="step-actions-ls">
                <button
                    onClick={handleBack}
                    className="btn-ls btn-secondary-ls"
                >
                    Volver
                </button>
            </div>

            {loading && <LoadingOverlay message="Cargando..." />}

            <ErrorModal message={error} onClose={() => setError("")} />
        </div>
    );
};

export default LocationScan;
